import { Component, OnInit, Input, Output, EventEmitter, ViewChild, } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { PuntoVisita } from '../Models/PuntoVisita';
import { Zona } from '../Models/Zona';
import { Ruta } from '../Models/Ruta';

import { GlobalsService } from '../services/globals.service';
import { ReportePuntoVisitaService } from '../services/reporte-punto-visita.service';
import { ZonaService } from '../services/zona.service';
import { RutaService } from '../services/ruta.service';

@Component({
  selector: 'app-reporte-punto-visita',
  templateUrl: './reporte-punto-visita.component.html',
  styleUrls: ['./reporte-punto-visita.component.css']
})
export class ReportePuntoVisitaComponent implements OnInit {

  public reportePuntoVisita: PuntoVisita = new PuntoVisita();
  public reportePuntoVisitas: PuntoVisita[];

  public zona: Zona = new Zona();
  public zonas: Zona[];
  public ruta: Ruta = new Ruta();
  public rutas: Ruta[];

  constructor(private reporteService: ReportePuntoVisitaService, private globalServices: GlobalsService,
    private zonaService: ZonaService, private rutaService: RutaService, ) {

  }

  ngOnInit() {
    this.CargarZonas();
  }


  CargarReportePuntoVisita() {
    try {


      if (this.rutas.length === 0) {
        this.ruta.idRuta = 0;
      }

      this.reporteService.ObtenerReportePuntosVisita(this.globalServices.ObtenerCompania(), this.zona.idZona, this.ruta.idRuta
      ).subscribe(
        data => {
          this.reportePuntoVisitas = data;


        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReportePuntoVisita: " + error);
    }

  }


  CargarZonas() {

    try {
      this.ruta.idRuta = 0;
      this.zonaService.ObtenerZonas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.zonas = data;
          this.ruta.idRuta = 0;

          this.rutas = [];

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("Cargarzonas: " + error);
    }
  }

  ZonaSeleccionada() {
    try {

      this.ruta.idRuta = 0;
      this.rutaService.ObtenerRutas(this.globalServices.ObtenerCompania(), this.zona.idZona.toString()).subscribe(
        data => {
          this.rutas = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("ZonaSeleccionada:" + error);
    }
  }




}
